import React from 'react'
import PageWithCard from '../../components/infrastructure/PageWithCard'
import FormikInputDateGroup from '../../components/formik/FormikInputDateGroup'
import { useFormik } from 'formik'
import FormikAsyncSelect from '../../components/formik/FormikAsyncSelect'
import QueryString from 'qs'
import { authAxiosInstance } from '../../utils/axiosConfig'
import { buildRange, exportCsv } from '../../utils/Utils'
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton'
import moment from 'moment'

export const CompanyReporting = () => {
    const formik = useFormik({
        initialValues: {
            from: '',
            to: '',
            company: '',
        },
        onSubmit: (async (values) => {
            try {
                const string = QueryString.stringify({
                    ...(values.company && { _id: values.company }),
                    $or: [
                        {
                            'visitForm.date': buildRange(values.from, values.to),
                        },
                        {
                            'complaint.createdAt': buildRange(values.from, values.to),
                        },
                    ],
                })
                const resp = await authAxiosInstance.get(`/company/reporting?${string}`)
                const rawData = resp?.data?.data ?? []
                const reportData = rawData.map((d, index) => ({
                    'S.NO': index + 1,
                    'DATE': d?.visitForm?.date ? moment(d.visitForm?.date).format('DD-MM-YYYY') : d.complaint?.createdAt ? moment(d.complaint?.createdAt).format('DD-MM-YYYY') : '',
                    'TYPE': d?.visitForm?._id ? 'Visit Form' : d?.complaint?._id ? 'Complaint' : '',
                    "ENGINEER'S NAME": d?.visitForm?.creatorName ? d?.visitForm?.creatorName : d?.complaint?.assignedTo ? d?.complaint?.assignedTo : '',
                    "SALES PERSON": d.executive?.map((e) => `${e.firstName} ${e.lastName}`.trim()).join(', ') ?? '',
                    'CUSTOMER': d.name ?? '',
                    'SHIFT': d?.visitForm?.shifts ?? '',
                    'STATUS': d?.complaint?.status ?? '',
                    'DESCRIPTION': d?.complaint?.description ?? '',
                    'TEAM': d?.visitForm?.team ? d?.visitForm?.team : d?.complaint?.team ? d?.complaint?.team : '',
                    'MACHINE WARRANTY': d?.visitForm?.machineWarranty ? d?.visitForm?.machineWarranty : d?.complaint?.machineWarranty ? d?.complaint?.machineWarranty : '',
                    'MACHINE NO': d?.visitForm?.machineNo ? d?.visitForm?.machineNo : d?.complaint?.machineNo ? d?.complaint?.machineNo : '',
                    'MATERIAL CONDITION': d.visitForm?.materialCondition ?? '',
                    'REMARK': d?.visitForm?.resolution ? d?.visitForm?.resolution : d?.complaint?.resolution ? d?.complaint?.resolution : '',
                    'COMPETITOR INK APPROACH': d?.visitForm?.competitorInkApproach ?? '',
                    'WHICH COMPETITOR INK': d?.visitForm?.whichCompetitorInk ?? '',
                    'COMPETITOR MACHINE APPROACH': d?.visitForm?.competitorMachineApproach ?? '',
                    'WHICH COMPETITOR MACHINE': d?.visitForm?.whichCompetitorMachine ?? ''
                }))
                console.log("reportData", reportData)
                await exportCsv(reportData)
                console.log("resp", resp)
            } catch (error) {
                console.log("error", error)
            }
        })
    })
    return (
        <PageWithCard>
            <form onSubmit={formik.handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    <FormikInputDateGroup
                        formik={formik}
                        label="From"
                        name="from"
                    />

                    <FormikInputDateGroup
                        formik={formik}
                        label="To"
                        name="to"
                    />

                    <FormikAsyncSelect
                        name="company"
                        label="Company"
                        formik={formik}
                        getOptions={async (value) => {
                            try {
                                const payload = {
                                    search: value,
                                    approvedStatus: 'approved',
                                };

                                const string = QueryString.stringify(payload);

                                const response = await authAxiosInstance.get(
                                    `/company?${string}`
                                );

                                return (
                                    response?.data?.data?.docs?.map((ele) => ({
                                        label: ele.name,
                                        value: ele._id,
                                    })) || []
                                );
                            } catch (error) {
                                console.log(error);
                                return [];
                            }
                        }}
                    />
                </div>

                <div className="flex justify-end">
                    <PrimaryButton type="submit">
                        Submit
                    </PrimaryButton>
                </div>
            </form>
        </PageWithCard>
    )
}
